var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    MergeObjectsBrickModel: function (opts) {
        var block = opts.block
            , editor = opts.editor
            , form = editor.find('form');

        Operator.Layout.setupCollections(form);

        form.on('submit', function (e) {
            Operator.blockEditors._generatePortsOnFormSubmit(e, editor, block, 'input', '.additional-input-port');
        });
    }
});